module.exports = __webpack_public_path__ + "static/media/game-interviewbutton.c66834d2.png";